import { makeStyles } from '@material-ui/core';
import { theme } from '../../../theme/theme';
import { StatusIcon, StatusType } from '../../global';
import React from 'react';
import clsx from 'clsx';

const useStatusCellClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 20px 15px 20px',
        borderRadius: 8,
        color: theme.colors.white,
        '&:hover': {
            background: theme.colors.darkBlue[2],
        },
        '& > span': {
            ...theme.typography.displays.d1,
            marginBottom: 10,
        },
        '&.selected': {
            background: theme.colors.darkBlue[2],
        },
    },
    statusIcon: {
        '& > span': {
            color: theme.colors.white,
            ...theme.typography.content.caption.paragraph,
            textTransform: 'capitalize',
        },
    },
});

export const ProjectListStatusCell = (props: {
    value: number;
    label: string;
    type: StatusType;
    icon: React.ReactNode;
    selected?: boolean;
    onClick?: () => void;
}) => {
    const classes = useStatusCellClasses();
    const cls = { selected: props.selected };

    return (
        <div className={clsx(classes.root, cls)} onClick={props.onClick} style={{ cursor: 'pointer' }} role={'button'}>
            <span>{props.value}</span>
            <StatusIcon className={classes.statusIcon} type={props.type} icon={props.icon}>
                {props.label}
            </StatusIcon>
        </div>
    );
};
